import React from 'react';
import ReactDOM from 'react-dom';
import './gtm-consent'; // <-- HIER IMPORTIEREN
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ToastProvider} from "react-toast-notifications";
import HttpsRedirect from 'react-https-redirect';
import "react-datepicker/dist/react-datepicker.css";

ReactDOM.render(
  <div>
      <HttpsRedirect>
          <ToastProvider>
              <App />
          </ToastProvider>
      </HttpsRedirect>
  </div>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
